import { Chip } from "@mui/material";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

const OutlinedSelectButton = ({
    label,
    selected,
    onClick,
    size = "medium",
    width = "100px",
}) => {
    return (
        <Chip
            label={label}
            variant="outlined"
            size={size}
            clickable
            onClick={onClick}
            deleteIcon={selected ? <RadioButtonCheckedIcon /> : null}
            onDelete={selected ? onClick : undefined}
            sx={{
                width,
                justifyContent: "space-between",
                px: 1,
                borderColor: selected ? "primary.main" : "grey.300",
                color: selected ? "primary.main" : "text.secondary",
                fontWeight: 500,
                borderRadius: 1,

                "& .MuiChip-label": {
                    flexGrow: 1,
                    textAlign: "left",
                    paddingLeft: 0,
                    overflow:"visible"
                },

                "& .MuiChip-deleteIcon": {
                    marginLeft: "auto",
                    color: "primary.main",
                    fontSize: 14,
                    mr: 0.5,
                },
            }}
        />
    );
};

export default OutlinedSelectButton;
